import React from 'react'
import ReactDOM from 'react-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import OnePagerReportIgr from '../view/onePagerReportIgr/OnePagerReportIgr';
import OnePagerReportLoan from "../view/OnePagerReportLoan";
import OnePagerReportTcp from '../view/onePagerReportTcp/OnePagerReportTcp';

interface GeneratePdfProps {
    loan: any;
    igr: any;
    tcp: any;
    generalData: any;
    filtersApplied: any;
    onLoading: (loading: boolean) => void;
    portfolioName: any
}

export const generatePDF = async ({ loan, igr, tcp, generalData, filtersApplied, onLoading, portfolioName }: GeneratePdfProps) => {

    onLoading?.(true);

    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.height = '2100px';
    container.style.left = '-9999px';
    document.body.appendChild(container);

    const pdf = new jsPDF('l', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();

    const renderPage = async (
        data: any,
        title: any,
        Component: React.FC<{ data: any; title: any; generalData: any; filtersApplied: any, portfolioName: any }>,

    ) => {
        ReactDOM.render(<Component data={data} title={title} generalData={generalData} filtersApplied={filtersApplied} portfolioName={portfolioName} />, container);

        await new Promise((resolve) => setTimeout(resolve, 600));

        const canvas = await html2canvas(container, { scale: 2 });
        const imgData = canvas.toDataURL('image/jpeg', 0.6);

        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
        pdf.addPage();
    };

    if (loan) await renderPage({ loan }, 'LON', OnePagerReportLoan);
    if (tcp) await renderPage({ tcp }, 'TCP', OnePagerReportTcp);
    if (igr) await renderPage({ igr }, 'IGR', OnePagerReportIgr);

    pdf.deletePage(pdf.getNumberOfPages());

    pdf.save(`one_pager_report.pdf`);

    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);

    onLoading?.(false);
};
